import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Divider,
  Box,
  Button,
  Typography,
  useMediaQuery
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Removeduplicates from "../common/Removeduplicate";
import { FETCH_USERS_WORK_HISTORY } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import { English } from "../../constant/EnglishFallback";
import { Add, Close, LocationOn } from "@mui/icons-material";

export default function SiteListModal(props) {
  const { openSiteListModal, setOpenSiteListModal, setSelectedSite, handleToggle } = props;
  const [userSiteList, setUserSiteList] = useState([]);
  const [isSiteLoading, setIsSiteLoading] = useState(false);
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const navigate = useNavigate();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm")); // mobile full screen

  const LanguageData = multiLanguageData?.SiteListModal || {};
  const {
    TEXT_SELECT_SITE = English?.SiteListModal?.TEXT_SELECT_SITE,
    TEXT_NO_ADDRESS = English?.SiteListModal?.TEXT_NO_ADDRESS,
    BUTTON_ADD_NEW_SITE = English?.SiteListModal?.BUTTON_ADD_NEW_SITE,
    TEXT_NO_SITE_FOUND = English?.SiteListModal?.TEXT_NO_SITE_FOUND,
    TEXT_ADD_SOME_SITE = English?.SiteListModal?.TEXT_ADD_SOME_SITE,
  } = LanguageData || {};

  const handleClose = () => setOpenSiteListModal(false);

  const handleSiteClick = (siteObj) => {
    setSelectedSite(siteObj);
    handleToggle();
    handleClose();
  };

  const getSites = async () => {
    setIsSiteLoading(true);
    try {
      let getObj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        // NrOfRecPerPage: 100,
        // UserId: Number(loginData?.userInformation?.UserId),
        SearchList: [{ UserId: loginData?.userInformation?.UserId }],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };
      const getSites = await Postrequestcall(
        FETCH_USERS_WORK_HISTORY,
        getObj,
        loginData?.accessToken
      );
      if (getSites?.status === 201) {
        let getUpdatedlist = Removeduplicates(getSites?.data?.data, "siteId");
        if (getUpdatedlist?.length > 0) {
          const sortedList = getUpdatedlist.sort((a, b) => b.id - a.id);
          setUserSiteList(sortedList);
        }
      }
    } catch (error) {
      console.log("getSites-> Error When Getting Sites: ", error);
      setIsSiteLoading(false);
    } finally {
      setIsSiteLoading(false);
    }
  };

  const handleAddSite = () => {
    navigate(`/${loginData?.userInformation?.UserId}`);
  };

  useEffect(() => {
    if (loginData?.userInformation?.UserId && loginData?.accessToken) {
      getSites();
    }
  }, []);

  return (
    <Dialog
      open={openSiteListModal}
      onClose={handleClose}
      fullScreen={fullScreen}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          height: fullScreen ? "100%" : "80vh",
          display: "flex",
          flexDirection: "column",
          borderRadius: fullScreen ? 0 : 3
        }
      }}>
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pr: 1
        }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {TEXT_SELECT_SITE}
        </Typography>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </DialogTitle>

      <Divider />
      {isSiteLoading ? (
        <Loader />
      ) : (
        <>
          {/* Scrollable list */}
          <Box sx={{ flex: 1, overflowY: "auto" }}>
            {userSiteList?.length > 0 ? (
              <List disablePadding>
                {userSiteList?.map((site, idx) => (
                  <React.Fragment key={idx}>
                    <ListItem
                      sx={{ alignItems: "flex-start", cursor: "pointer" }}
                      onClick={() => handleSiteClick(site)}>
                      <ListItemText
                        primary={site?.siteName}
                        secondary={
                          site?.address
                            ? `${site?.address}, ${site?.country}, ${site?.province}`
                            : TEXT_NO_ADDRESS
                        }
                        primaryTypographyProps={{
                          fontWeight: 500,
                          fontSize: "0.95rem"
                        }}
                        secondaryTypographyProps={{
                          fontSize: "0.85rem",
                          color: "text.secondary"
                        }}
                      />
                    </ListItem>
                    <Divider component="li" />
                  </React.Fragment>
                ))}
              </List>
            ) : (
              <Box
                sx={{
                  height: "50vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  textAlign: "center",
                  color: "text.secondary",
                }}>
                <LocationOn sx={{ fontSize: 40, color: "text.disabled", mb: 1 }} />
                <Typography variant="body1" fontWeight={500}>
                  {TEXT_NO_SITE_FOUND}
                </Typography>
                <Typography variant="body2">{TEXT_ADD_SOME_SITE}</Typography>
              </Box>
            )}
          </Box>

          {/* Sticky footer */}
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              bgcolor: "background.paper",
              p: 1,
              borderTop: "1px solid #ddd",
              textAlign: "center"
            }}>
            <Button
              variant="text"
              fullWidth
              sx={{
                textTransform: "none",
                fontWeight: 500,
                "& .MuiButton-startIcon": {
                  marginRight: "2px"
                }
              }}
              onClick={handleAddSite}
              startIcon={<Add sx={{ fontSize: "18px" }} />}>
              {BUTTON_ADD_NEW_SITE}
            </Button>
          </Box>
        </>
      )}
    </Dialog>
  );
}
